import ApiClient from './ApiClient';

class LabelsAPI extends ApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }
}

export default new LabelsAPI();
